'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reset = exports.play = exports.next = exports.getSubscribedTopics = exports.getPageTopics = exports.setValues = exports.setValue = undefined;
exports.useStub = useStub;

var _connector = require('./connector/');

var _providers = require('./providers/');

var stubInstance = (0, _providers.getStub)();
function useStub() {
    (0, _connector.setProvider)(stubInstance.provider);
}
var setValue = stubInstance.setValue,
    setValues = stubInstance.setValues,
    getPageTopics = stubInstance.getPageTopics,
    getSubscribedTopics = stubInstance.getSubscribedTopics,
    next = stubInstance.next,
    play = stubInstance.play,
    reset = stubInstance.reset;
exports.setValue = setValue;
exports.setValues = setValues;
exports.getPageTopics = getPageTopics;
exports.getSubscribedTopics = getSubscribedTopics;
exports.next = next;
exports.play = play;
exports.reset = reset;


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/stubController.js
// module id = 2151
// module chunks = 1